import { configureStore } from "@reduxjs/toolkit";
import recipeDetailReducer from "store/slices/recipe/recipeDetailSlice";
import foodItemOptionsReducer from "store/slices/food/foodItemOptionsSlice";
import foodTagOptionsReducer from "store/slices/food/foodTagOptionsSlice";
import foodGroupsReducer from "store/slices/food/foodGroupSlice";
import foodTagBatchOperationReducer from "store/slices/food/foodTagBatchOperationSlice";
import foodItemDetailReducer from "store/slices/foodItem/foodItemDetailSlice";
import foodStockDetailReducer from "store/slices/inventory/foodStockDetailSlice";
import menuDetailReducer from "store/slices/menu/menuDetailSlice";
import menuLoopDetailReducer from "store/slices/menu/menuLoopDetailSlice";
import menusOnDateReducer from "store/slices/menu/menusOnDateSlice";
import menuBatchOperationReducer from "store/slices/menu/menuBatchOperationSlice";
import dishPortionOrdersReducer from "store/slices/order/dishPortionOrdersSlice";
import foodPurchaseGuideReducer from "store/slices/inventory/foodPurchasingGuideSlice";
import restockingReducer from "store/slices/inventory/restockingSlice";
import supplyProfileReducer from "store/slices/inventory/supplyProfileSlice";
import menuOptionsReducer from "store/slices/menu/menuOptionsSlice";
import weekMenuViewDetailsReducer from "store/slices/menu/menusInWeekSlice";
import userGroupOptionsReducer from "store/slices/userGroup/userGroupOptionsSlice";
import currentSiteReducer from "store/slices/userGroup/currentSiteSlice";
import userAccountReducer from "store/slices/user/userAccountSlice";
import invoiceUpdateSupplierInfoReducer from "./slices/foodItem/invoiceUpdateSupplierInfoSlice";

const store = configureStore({
  reducer: {
    userGroupOptions: userGroupOptionsReducer,
    currentSite: currentSiteReducer,
    userAccount: userAccountReducer,
    foodItemOptions: foodItemOptionsReducer,
    foodTagOptions: foodTagOptionsReducer,
    foodTagBatchOperation: foodTagBatchOperationReducer,
    foodGroups: foodGroupsReducer,
    recipeDetail: recipeDetailReducer,
    foodItemDetail: foodItemDetailReducer,
    invoiceUpdateSupplierInfo: invoiceUpdateSupplierInfoReducer,
    menuOptions: menuOptionsReducer,
    menuDetail: menuDetailReducer,
    menuLoopDetail: menuLoopDetailReducer,
    menuBatchOperation: menuBatchOperationReducer,
    weeklyMenus: weekMenuViewDetailsReducer,
    dailyMenus: menusOnDateReducer,
    foodStockDetail: foodStockDetailReducer,
    dishPortionOrders: dishPortionOrdersReducer,
    foodPurchasingGuide: foodPurchaseGuideReducer,
    restocking: restockingReducer,
    supplyProfiles: supplyProfileReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
